<template>
    <div class="sw-modal">
        <div v-click-outside="close" class="sw-modal-content form__preview">
            <div class="row sw-modal-heading">
                <div class="col text-center">
                    <h4>
                        <i class="fab fa-wpforms"></i>
                        {{automation.name}}
                    </h4>
                    <h6>Edit quickly now, in detail later</h6>
                    <h6>Use the checkboxes to include / exclude questions</h6>
                </div>
            </div>
            <div class="sw-modal-body">
                <div v-for="(section, sindex) in automation.formTemplate.sections" v-bind:key="sindex" class="form__preview__section">
                    {{section.title}}
                    <div v-for="(question, qindex) in section.questions" v-bind:key="qindex" class="form__preview__question">
                        <span>{{question.question}}</span>
                        <input type="checkbox" v-model="question.selected">
                    </div>
                </div>
                <div>
                    <button class="btn btn-primary" v-on:click.stop="close">Done</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {automationsMixin} from '../../mixins/AutomationsMixin'

    export default {
        name: "FormPreview.vue",
        // components: {},
        components: {},
        mixins: [automationsMixin],
        props: {
            automation: Object
        },
        data: function () {
            return {
                showTooltip: false
            }
        },
        computed: {},
        methods: {
            close: function () {
                this.$root.$emit('finished-previewing-form');
            },
        }
    }

</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/pages/create-account";
</style>